import {WithPermissionModel} from '../../../../../../../common/permission/api/entity/withPermission.model';
import {
    CommunicationConfigurationEmailModel
} from '../../../../../../../communication/configuration/email/common/api/model/communicationConfigurationEmail.model';
import {LovValueSummary} from '../../../../../../../common/lov/lov-value/api/model/lovValueSummary.model';
import {UserSummary} from "../../../../../../../account/modules/user/api/entity/userSummary.model";

export class SaleInvoiceConfigurationBookModel extends WithPermissionModel {

    id: number;
    prefix: string;
    nextNumber: number;
    autoGenerateNumber: boolean;
    user: UserSummary;
    label: string;
    active: boolean;
}
